export default {
  convertLocationFromMapboxAutocompleteItem(item) {
    let {
      text: shortName,
      place_name_fr: longName,
      place_type: placeType,
      center: coordinates,
      bbox: bbox,
      id: id
    } = item;
    placeType = placeType[0];
    if (placeType === "region") {
      placeType = "department";
    }
    return { shortName, longName, placeType, coordinates, bbox, id };
  }
};
